import { useRef as i, useEffect as o } from "react";
const d = ({ messageId: c = 1192723 }) => {
  const s = i(c);
  return o(() => {
    const t = (e) => {
      var a;
      e.preventDefault(), (a = window._sp_) != null && a.usnat ? window._sp_.usnat.loadPrivacyManagerModal(s.current) : console.warn("Sourcepoint usnat not found.");
    };
    let n = 0;
    const r = setInterval(() => {
      n++;
      const e = document.querySelector(".privacy-preferences-trigger");
      e && !e.getAttribute("data-sp-listener-added") ? (e.addEventListener("click", t), e.setAttribute("data-sp-listener-added", !0), clearInterval(r)) : e && e.getAttribute("data-sp-listener-added") && clearInterval(r), n > 1e3 && (clearInterval(r), console.warn("Privacy preference button not found."));
    }, 100);
    return () => {
      const e = document.querySelector(".privacy-preferences-trigger");
      e && e.removeEventListener("click", t), clearInterval(r);
    };
  }), null;
};
export {
  d as default
};
